import { useGetSearchConditionGroupsByCategoryId } from "@/features/search_product";
import { SearchConditionGroupResponse } from "@/web-client";
import { useMemo } from "react";

interface SelectedSearchConditionGroups {
  selectedSearchConditionGroups?: SearchConditionGroupResponse[];
}

export const useSelectedSearchConditionGroups = (
  selectedSearchConditionValueIds: number[],
  categoryId?: number,
): SelectedSearchConditionGroups => {
  const { data: searchConditionGroups } =
    useGetSearchConditionGroupsByCategoryId(categoryId);

  const selectedSearchConditionGroups = useMemo<
    SearchConditionGroupResponse[]
  >(() => {
    if (!searchConditionGroups) return undefined;

    return searchConditionGroups.map((group) => {
      // group.valuesのなかから、selectedSearchConditionValueIdsに含まれるものを抽出
      const values = group.values.filter((value) =>
        selectedSearchConditionValueIds.includes(value.id),
      );

      return {
        ...group,
        values,
      };
    });
  }, [searchConditionGroups, selectedSearchConditionValueIds]);

  return { selectedSearchConditionGroups };
};
